import { Alert, StyleSheet, Platform, Modal } from 'react-native';
import styled, { ThemeProvider as ThemeProvider$1, css, useTheme } from 'styled-components/native';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import theme from 'styled-theming';
import ReactModal from 'react-modal';
import TagManager from 'react-gtm-module';
import axios from 'axios';
import _ from 'lodash';
import { PublicClientApplication } from '@azure/msal-browser';
import { DateTime } from 'luxon';
import { rrulestr, RRuleSet } from 'rrule';
import moment from 'moment';

var index = (function (title, desc, onPress) {
    if (onPress === void 0) { onPress = function () { }; }
    Alert.alert(title, desc);
    if (onPress)
        onPress();
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var ThemeProvider = function (props) {
    var theme = props.theme, children = props.children;
    return (jsx(ThemeProvider$1, __assign({ theme: theme }, { children: jsx(BackgroundView, { children: children }, void 0) }), void 0));
};
var BackgroundView = styled.View(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1;\n  background-color: ", ";\n"], ["\n  flex: 1;\n  background-color: ", ";\n"])), function (props) { return props.theme.palette.background; });
var templateObject_1;

var ThemeUtil = {
    getThemeValue: function (themeObject) {
        return function (mode) { return themeObject({ theme: { mode: mode } }); };
    },
    getInvertedThemeValue: function (themeObject) {
        return function (mode) {
            return themeObject({ theme: { mode: mode === 'light' ? 'dark' : 'light' } });
        };
    },
    createTheme: function (name, values, inverted) {
        if (inverted) {
            var invertedValues = { light: values.dark, dark: values.light };
            return theme(name, invertedValues);
        }
        return theme(name, values);
    },
    createThemeWithVariant: function (name, variant, values, inverted) {
        if (inverted) {
            var invertedValues = Object.keys(values).reduce(function (result, key) {
                var value = values[key];
                result[key] = { light: value.dark, dark: value.light };
                return result;
            }, {});
            return theme.variants(name, variant, invertedValues);
        }
        return theme.variants(name, variant, values);
    }
};

var fontSize = {
    h1: 40,
    h2: 24,
    h3: 18,
    h4: 14,
    h5: 16,
    button: 16,
    body1: 16,
    body2: 16,
    body3: 14,
    body4: 14,
    caption: 14,
};
var letterSpacing = {
    h2: fontSize.h2 * 0.01,
    h3: fontSize.h3 * 0.055,
    h4: fontSize.h4 * 0.05,
    h5: fontSize.h4 * 0.05,
    button: fontSize.button * 0.05,
};
var fontFamily = {
    h1: 'Outfit_600SemiBold',
    h2: 'Outfit_600SemiBold',
    h3: 'Outfit_600SemiBold',
    h4: 'Outfit_600SemiBold',
    h5: 'Outfit_500Medium',
    button: 'Outfit_600SemiBold',
    body1: 'Outfit_400Regular',
    body2: 'Outfit_600SemiBold',
    body3: 'Outfit_500Medium',
    body4: 'Outfit_400Regular',
    caption: 'Outfit_600SemiBold',
};
var fontWeight = {
    h1: '600',
    h2: '700',
    h3: '600',
    h4: '600',
    h5: '500',
    button: '600',
    body1: '400',
    body2: '600',
    body3: '500',
    body4: '400',
    caption: '400',
};
var textTransform = {
    h4: 'uppercase',
};
var lineHeight = {
    h1: '40px',
    h2: '20px',
    h3: '18px',
    h5: '19px',
    button: '20px',
    body1: '16px',
    body2: '18px',
    body4: '18px',
    caption: '16px',
};
var color = function (props) {
    var _a;
    var colors = props.theme.color;
    var inverted = (_a = props.inverted) !== null && _a !== void 0 ? _a : false;
    return ThemeUtil.createThemeWithVariant('mode', 'color', {
        primary: { light: colors.grey5, dark: colors.white },
        secondary: { light: colors.grey4, dark: colors.grey4 },
        tertiary: { light: colors.grey4, dark: colors.grey3 },
        quaternary: { light: colors.quaternary, dark: colors.primaryDark },
        disabled: { light: 'rgba(0, 0, 0, 0.38)', dark: 'rgba(255, 255, 255, 0.5)' },
        hint: { light: colors.grey4, dark: colors.grey3 },
        title: { light: colors.grey7, dark: colors.grey2 },
        error: { light: colors.destructive, dark: colors.destructive },
        inactive: { light: colors.grey2, dark: colors.grey7 },
    }, inverted);
};
// TODO: react-native-size-matters
var Text = styled.Text(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  letter-spacing: ", ";\n  font-weight: ", ";\n  color: ", ";\n  text-align: left;\n  text-transform: ", ";\n  line-height: ", ";\n  text-decoration-line: ", ";\n  text-decoration-color: ", "; \n"], ["\n  font-family: ", ";\n  font-size: ",
    ";\n  letter-spacing: ",
    ";\n  font-weight: ", ";\n  color: ", ";\n  text-align: left;\n  text-transform: ", ";\n  line-height: ", ";\n  text-decoration-line: ", ";\n  text-decoration-color: ", "; \n"])), function (props) { return fontFamily["" + props.variant]; }, function (props) { var _a; return ((_a = props.fontSize) !== null && _a !== void 0 ? _a : fontSize["" + props.variant]) + "px"; }, function (props) {
    var _a;
    return props.letterSpacing != null
        ? props.letterSpacing
        : ((_a = letterSpacing["" + props.variant]) !== null && _a !== void 0 ? _a : 0) + "px";
}, function (props) { var _a; return (_a = props.fontWeight) !== null && _a !== void 0 ? _a : fontWeight["" + props.variant]; }, function (props) { var _a; return (_a = props.fontColor) !== null && _a !== void 0 ? _a : color(props); }, function (props) { var _a; return (_a = textTransform["" + props.variant]) !== null && _a !== void 0 ? _a : 'none'; }, function (props) { var _a; return (_a = props.lineHeight) !== null && _a !== void 0 ? _a : lineHeight["" + props.variant]; }, function (props) { var _a; return (_a = "" + (props.underline ? 'underline' : 'none')) !== null && _a !== void 0 ? _a : 'underline'; }, function (props) { var _a; return (_a = props.fontColor) !== null && _a !== void 0 ? _a : color(props); });
var StyledText = function (props) {
    return jsx(Text, __assign({}, props), void 0);
};
StyledText.defaultProps = {
    variant: 'body1',
    color: 'primary',
    inverted: false,
    underline: false,
    ellipsizeMode: 'tail',
};
var templateObject_1$1;

var backgroundColor = function (props) {
    var _a;
    var colors = props.theme.color;
    var inverted = (_a = props.inverted) !== null && _a !== void 0 ? _a : false;
    return ThemeUtil.createThemeWithVariant("mode", "variant", {
        monochrome: { light: colors.white, dark: colors.black },
        primary: { light: colors.primaryLight, dark: colors.primaryDark },
        destructive: { light: colors.destructive, dark: colors.destructive },
        cancel: { light: colors.white, dark: colors.black },
        light: { light: colors.white, dark: colors.white },
        transparent: { light: colors.grey6, dark: colors.white },
    }, inverted);
};
var StyledButton = styled.TouchableOpacity(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  display: flex;\n  min-width: 148px;\n  height: 48px;\n  padding: 16px 24px;\n  justify-content: center;\n  align-items: center;\n  border: ", ";\n  background-color: ", ";\n  opacity: ", ";\n  border-radius: 32px;\n"], ["\n  display: flex;\n  min-width: 148px;\n  height: 48px;\n  padding: 16px 24px;\n  justify-content: center;\n  align-items: center;\n  border: ", ";\n  background-color: ", ";\n  opacity: ", ";\n  border-radius: 32px;\n"])), function (props) { return (props.border ? '1px solid ' + props.border : 'none'); }, function (props) { return backgroundColor(props); }, function (props) { return (props.disabled ? 0.5 : 1); });
StyledButton.defaultProps = {
    variant: "primary",
    color: "primary",
    disabled: false,
    disableElevation: false,
    inverted: false,
};
var Button = function (props) {
    return (jsx(StyledButton, __assign({}, props, { children: jsx(StyledText, __assign({ variant: "button", fontColor: props.fontColor, color: props.color, inverted: true }, { children: props.title }), void 0) }), void 0));
};
var templateObject_1$2;

var color$1 = function (props) {
    var colors = props.theme.color;
    return theme('mode', {
        light: colors.grey5,
        dark: colors.grey4,
    });
};
var margin = theme.variants('mode', 'variant', {
    middle: {
        light: css(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n      margin-left: 16px;\n      margin-right: 16px;\n      opacity: 0.25;\n    "], ["\n      margin-left: 16px;\n      margin-right: 16px;\n      opacity: 0.25;\n    "]))),
        dark: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-left: 16px;\n      margin-right: 16px;\n      opacity: 0.25;\n    "], ["\n      margin-left: 16px;\n      margin-right: 16px;\n      opacity: 0.25;\n    "]))),
    },
    fullWidth: {
        light: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      opacity: 0.25;\n    "], ["\n      opacity: 0.25;\n    "]))),
        dark: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      opacity: 0.25;\n    "], ["\n      opacity: 0.25;\n    "]))),
    },
});
// border-top isn't supported
var Divider = styled.View(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0;\n  flex-shrink: 0;\n  border-width: 0;\n  align-self: stretch;\n  background: ", ";\n  height: ", ";\n  ", "\n"], ["\n  margin: 0;\n  flex-shrink: 0;\n  border-width: 0;\n  align-self: stretch;\n  background: ", ";\n  height: ", ";\n  ", "\n"])), function (props) { return color$1(props); }, StyleSheet.hairlineWidth + "px", margin);
var templateObject_1$3, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

ReactModal.setAppElement('body');
var ModalView = function (props) {
    if (Platform.OS === 'web') {
        return (jsx(ReactModal, __assign({ onRequestClose: props.onDismiss, isOpen: props.isVisible, shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true, style: {
                //https://reactcommunity.org/react-modal/styles/
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.50)',
                },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 0,
                    maxHeight: 'calc(100vh - 64px)',
                    backgroundColor: 'transparent',
                    borderStyle: 'hidden',
                },
            } }, { children: props.children }), void 0));
    }
    else {
        return (jsx(Modal, __assign({ visible: props.isVisible, style: styles.container }, { children: props.children }), void 0));
    }
};
var styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
});

ReactModal.setAppElement('body');
var OverlayView = function (props) {
    if (Platform.OS === 'web') {
        return (jsx(ReactModal, __assign({ onRequestClose: props.onDismiss, isOpen: props.isVisible, shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true, style: {
                //https://reactcommunity.org/react-modal/styles/
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                },
                content: {
                    top: props.top ? props.top : '50%',
                    left: props.left ? props.left : '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 0,
                    maxHeight: 'calc(100vh - 64px)',
                },
            } }, { children: props.children }), void 0));
    }
    else {
        return (jsx(Modal, __assign({ visible: props.isVisible, style: styles$1.container }, { children: props.children }), void 0));
    }
};
var styles$1 = StyleSheet.create({
    container: {
        flexDirection: 'column',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
});

var palette = {
    primary: theme('mode', {
        light: '#AED0B7',
        dark: '#8DC89D',
    }),
    secondary: theme('mode', {
        light: '#446A4E',
        dark: '#8DC89D',
    }),
    tertiary: theme('mode', {
        light: '#7D7D7D',
        dark: '#999999',
    }),
    destructive: theme('mode', {
        light: '#FF6A6A',
        dark: '#FF6A6A',
    }),
    error: theme('mode', {
        light: '#FF6A6A',
        dark: '#FF6A6A',
    }),
    warning: theme('mode', {
        light: '#EEBC09',
        dark: '#EEBC09',
    }),
    info: theme('mode', {
        light: '#000',
        dark: '#FFF',
    }),
    success: theme('mode', {
        light: '#3A6445',
        dark: '#3A6445',
    }),
    common: theme('mode', {
        light: '#FFFFFF',
        dark: '#111111',
    }),
    border: theme('mode', {
        light: '#333333',
        dark: '#7D7D7D',
    }),
    background: theme('mode', {
        light: '#FCFCFC',
        dark: '#1C1C1C',
    }),
    disable: theme('mode', {
        light: '#999',
        dark: '#999',
    }),
    text: theme.variants('mode', 'color', {
        primary: { light: '#202020', dark: '#FFFFFF' },
        secondary: { light: '#7D7D7D', dark: '#7D7D7D' },
        tertiary: { light: '#7D7D7D', dark: '#999999' },
        quaternary: { light: '#446A4E', dark: '#8DC89D' },
        disabled: { light: 'rgba(0, 0, 0, 0.38)', dark: 'rgba(255, 255, 255, 0.5)' },
        hint: { light: '#7d7d7d', dark: '#999999' },
        title: { light: '#595959', dark: '#C5C5C5' },
        error: { light: '#FF6A6A', dark: '#FF6A6A' },
        inactive: { light: '#C5C5C5', dark: '#595959' },
    }),
    action: theme.variants('mode', 'state', {
        active: { light: 'rgba(0, 0, 0, 0.87)', dark: '#fff' },
        hover: { light: 'rgba(0, 0, 0, 0.87)', dark: '#fff' },
        hoverOpacity: { light: 'rgba(0, 0, 0, 0.87)', dark: '#fff' },
        selected: { light: 'rgba(0, 0, 0, 0.87)', dark: '#fff' },
        selectedOpacity: { light: 'rgba(0, 0, 0, 0.87)', dark: '#fff' },
        disabled: { light: 'rgba(0, 0, 0, 0.87)', dark: '#fff' },
        disabledBackground: { light: 'rgba(0, 0, 0, 0.87)', dark: '#fff' },
        disabledOpacity: { light: 'rgba(0, 0, 0, 0.87)', dark: '#fff' },
        focus: { light: 'rgba(0, 0, 0, 0.87)', dark: '#fff' },
        focusOpacity: { light: 'rgba(0, 0, 0, 0.87)', dark: '#fff' },
        activatedOpacity: { light: 'rgba(0, 0, 0, 0.87)', dark: '#fff' },
    }),
};
var colors = {
    grey1: '#F2F2F2',
    grey2: '#C5C5C5',
    grey3: '#999999',
    grey4: '#7D7D7D',
    grey5: '#E0E0E0',
    grey6: '#222222',
    grey7: '#595959',
    white: '#FFFFFF',
    black: '#202020',
    primaryLight: '#297F6F',
    primaryDark: '#8DC89D',
    destructive: '#FF6A6A',
    quaternary: '#446A4E',
};
var shadow = theme('mode', {
    light: '0px 3px 6px rgba(0, 0, 0, 0.1)',
    dark: '0px 5px 10px rgba(0, 0, 0, 0.6)',
});

const event = {
  EventName: 'eventGA',
  WelcomeOrganization: 'Welcome - Publicis Organization',
  WelcomeOffice: 'Welcome - Office City',
  Click: 'Click',
  Navigation: 'Navigation',
  Profile: 'Profile',
  DashboardBook: 'Dashboard - Book a Space',
  DashboardOffice: 'Dashboard - Office',
  DashboardReservations: 'Dashboard - My reservations',
  CancelReservation: 'Delete a reservation',
  Error: 'Error',

  //GA4 events :
  GA4Navigation: 'navigation_click',
  GA4Profile: 'profile_click',
  GA4BookSpace: 'book_space',
  GA4SelectDate: 'select_date',
  GA4Employee: 'employee_present_click',
  GA4EditBooking: 'modify_reservation',
  GA4DeleteBooking: 'delete_reservation',
  GA4Button: 'button_click',
  GA4Map: 'map_click',
  GA4SelectSpace: 'select_desk',
  GA4ConfirmBooking: 'confirm_reservation',
  // GA4 page event
  GA4PageHome: 'home',
  GA4PageBooking: 'home',
};

var Dialog = function (_a) {
    var title = _a.title, body = _a.body, isOpen = _a.isOpen, onClose = _a.onClose, actionTitle = _a.actionTitle, cancelTitle = _a.cancelTitle, cancelVariant = _a.cancelVariant, cancelInverted = _a.cancelInverted, cancelBorder = _a.cancelBorder, cancelFontColor = _a.cancelFontColor, onbuttonAction = _a.onbuttonAction, closeIcon = _a.closeIcon;
    useTheme();
    return (jsx(ModalView, __assign({ isVisible: isOpen, onDismiss: onClose }, { children: jsxs(DialogView, { children: [closeIcon &&
                    jsx(CloseContainer, __assign({ onPress: onClose }, { children: jsx("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "#111111", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.586 11.9999L5.63623 16.9497L7.05044 18.3639L12.0002 13.4142L16.9499 18.3639L18.3642 16.9497L13.4144 11.9999L18.3642 7.0502L16.9499 5.63599L12.0002 10.5857L7.05044 5.63599L5.63623 7.0502L10.586 11.9999Z", fill: "current" }, void 0) }), void 0) }), void 0),
                jsxs(TopContainer, { children: [title && (jsx(TitleContainer, { children: jsx(StyledText, __assign({ color: 'primary', variant: 'h3' }, { children: title }), void 0) }, void 0)),
                        jsx(Divider, { variant: 'middle' }, void 0),
                        body && (jsx(TextContainer, { children: jsx(CenteredText, __assign({ color: 'primary', variant: 'body1' }, { children: body }), void 0) }, void 0))] }, void 0),
                !closeIcon && (jsx(Fragment, { children: actionTitle ? (jsxs(ButtonContainer, { children: [jsx(Button, { title: actionTitle, variant: 'monochrome', fontColor: colors.primaryLight, onPress: onbuttonAction, border: colors.primaryLight }, void 0),
                            jsx(Button, { title: cancelTitle !== null && cancelTitle !== void 0 ? cancelTitle : 'Cancel', variant: cancelVariant ? cancelVariant : 'primary', inverted: cancelInverted ? cancelInverted : false, disableElevation: true, border: cancelBorder ? cancelBorder : '', color: cancelFontColor !== null && cancelFontColor !== void 0 ? cancelFontColor : 'primary', fontColor: cancelFontColor, onPress: onClose }, void 0)] }, void 0)) :
                        jsx(CancelButtonContainer, { children: jsx(Button, { title: cancelTitle !== null && cancelTitle !== void 0 ? cancelTitle : 'Cancel', variant: 'monochrome', inverted: cancelInverted ? cancelInverted : false, disableElevation: true, border: colors.primaryLight, color: 'primary', fontColor: colors.primaryLight, onPress: function () {
                                    onClose();
                                    TagManager.dataLayer({
                                        dataLayer: {
                                            category: event.Error,
                                            action: body !== null && body !== void 0 ? body : event.Error,
                                            label: cancelTitle
                                        }
                                    });
                                } }, void 0) }, void 0) }, void 0))] }, void 0) }), void 0));
};
var TitleContainer = styled.View(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: 16px 24px;\n"], ["\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: 16px 24px;\n"])));
var CenteredText = styled(StyledText)(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var ButtonContainer = styled.View(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  width: 100%;\n  margin-bottom: 24px;\n  flex-direction: row;\n  padding: 0 16px;\n  justify-content: space-between;\n"], ["\n  width: 100%;\n  margin-bottom: 24px;\n  flex-direction: row;\n  padding: 0 16px;\n  justify-content: space-between;\n"])));
var TextContainer = styled.View(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  padding: 24px;\n  width: 100%;\n  min-height: 32px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  padding: 24px;\n  width: 100%;\n  min-height: 32px;\n  justify-content: center;\n  align-items: center;\n"])));
var TopContainer = styled.View(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n"], ["\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n"])));
var DialogView = styled.View(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 343px;\n  width: 100%;\n  box-shadow: ", ";\n  background-color: ", ";\n  border-radius: 16px;\n"], ["\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 343px;\n  width: 100%;\n  box-shadow: ", ";\n  background-color: ", ";\n  border-radius: 16px;\n"])), shadow, palette.common);
var CloseContainer = styled.TouchableOpacity(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  z-index: 10;\n  top: 10px;\n  right: 10px;\n"], ["\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  z-index: 10;\n  top: 10px;\n  right: 10px;\n"])));
var CancelButtonContainer = styled.View(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin-bottom: 24px;\n"], ["\n  margin-bottom: 24px;\n"])));
var templateObject_1$4, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6, templateObject_7, templateObject_8;

var SvgIcon = function (_a) {
    var svg = _a.svg, fillColor = _a.fillColor, width = _a.width, height = _a.height, inverted = _a.inverted;
    var theme = useTheme();
    var invertedColor = inverted
        ? ThemeUtil.getInvertedThemeValue(theme.palette.common)(theme.mode)
        : ThemeUtil.getThemeValue(theme.palette.common)(theme.mode);
    var props = {
        fill: fillColor ? fillColor : invertedColor,
        width: width !== null && width !== void 0 ? width : 24,
        height: height !== null && height !== void 0 ? height : 24,
    };
    return svg(props);
};

var iconSize = function (size) {
    switch (size) {
        case "xsmall":
            return 24;
        case "small":
            return 32;
        case "medium":
            return 36;
        case "large":
            return 40;
        case "xlarge":
            return 48;
        default:
            return 40;
    }
};
var strokeSize = function (size) {
    return iconSize(size !== null && size !== void 0 ? size : "small") + 12;
};
var svgSize = function (size) {
    switch (size) {
        case "small":
            return 32;
        default:
            return 24;
    }
};
var renderDoubleStrokeIcon = function (svg, styleName, variant, accessibilityLabel, inverted, size, tintColor, fillColor) {
    return (jsx(AdditionnalStroke, __assign({ styleName: styleName, inverted: inverted, size: size }, { children: jsx(StyledContainer, __assign({ styleName: styleName, size: size, inverted: inverted, variant: variant, fillColor: fillColor, accessibilityLabel: accessibilityLabel }, { children: jsx(SvgIcon, { svg: svg, fillColor: tintColor, inverted: inverted, width: svgSize(size), height: svgSize(size) }, void 0) }), void 0) }), void 0));
};
var renderSimpleStrokeIcon = function (svg, styleName, variant, accessibilityLabel, inverted, size, tintColor, fillColor) {
    return (jsx(StyledContainer, __assign({ styleName: styleName, size: size, inverted: inverted, variant: variant, fillColor: fillColor, accessibilityLabel: accessibilityLabel }, { children: jsx(SvgIcon, { svg: svg, fillColor: tintColor, inverted: inverted, width: svgSize(size), height: svgSize(size) }, void 0) }), void 0));
};
var CircularIcon = function (_a) {
    var svg = _a.svg, _b = _a.size, size = _b === void 0 ? "small" : _b, tintColor = _a.tintColor, fillColor = _a.fillColor, _c = _a.inverted, inverted = _c === void 0 ? false : _c, _d = _a.variant, variant = _d === void 0 ? "stroke" : _d, accessibilityLabel = _a.accessibilityLabel;
    var styleName = useTheme().mode;
    var render = variant === "fill-stroke" ?
        renderDoubleStrokeIcon(svg, styleName, variant, accessibilityLabel, inverted, size, tintColor, fillColor) :
        renderSimpleStrokeIcon(svg, styleName, variant, accessibilityLabel, inverted, size, tintColor, fillColor);
    return render;
};
var AdditionnalStroke = styled.View(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  border: 1px solid\n    ", ";\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15); \n"], ["\n  border: 1px solid\n    ",
    ";\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15); \n"])), function (props) {
    return props.inverted
        ? ThemeUtil.getInvertedThemeValue(props.theme.palette.border)(props.styleName)
        : ThemeUtil.getThemeValue(props.theme.palette.border)(props.styleName);
}, function (props) { var _a; return strokeSize((_a = props.size) !== null && _a !== void 0 ? _a : "small") + "px"; }, function (props) { var _a; return strokeSize((_a = props.size) !== null && _a !== void 0 ? _a : "small") + "px"; }, function (props) { var _a; return (strokeSize((_a = props.size) !== null && _a !== void 0 ? _a : "small")) / 2 + "px"; });
var StyledContainer = styled.View(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  align-items: center;\n  justify-content: center;\n  margin: 8px;\n"], ["\n  background-color: ",
    ";\n  border: 1px solid\n    ",
    ";\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  align-items: center;\n  justify-content: center;\n  margin: 8px;\n"])), function (props) {
    var _a;
    return props.variant === "fill" || props.variant === "fill-stroke"
        ? (_a = props.fillColor) !== null && _a !== void 0 ? _a : props.theme.palette.primary : "transparent";
}, function (props) {
    return props.variant === "stroke"
        ? props.inverted
            ? ThemeUtil.getInvertedThemeValue(props.theme.palette.common)(props.styleName)
            : ThemeUtil.getThemeValue(props.theme.palette.common)(props.styleName)
        : "transparent";
}, function (props) { var _a; return iconSize((_a = props.size) !== null && _a !== void 0 ? _a : "small") + "px"; }, function (props) { var _a; return iconSize((_a = props.size) !== null && _a !== void 0 ? _a : "small") + "px"; }, function (props) { var _a; return iconSize((_a = props.size) !== null && _a !== void 0 ? _a : "small") / 2 + "px"; });
var templateObject_1$5, templateObject_2$2;

var msalConfig = function (config) {
    return {
        auth: {
            clientId: config.msClientId,
            redirectUri: config.redirectUrl,
            authority: 'https://login.microsoftonline.com/organizations/'
        },
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: false
        }
    };
};
var loginRequest = {
    scopes: ['openid', 'profile', 'User.Read']
};
var logoutRequest = function (accountInfo) {
    var request = {
        account: accountInfo || undefined
    };
    return request;
};
var tokenRequest = function (accountInfo) {
    var request = {
        scopes: ['User.Read'],
        account: accountInfo
    };
    return request;
};

var AuthManager = /** @class */ (function () {
    function AuthManager(config) {
        var _this = this;
        this.signIn = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.client.loginRedirect(loginRequest);
                return [2 /*return*/];
            });
        }); };
        this.signOut = function () { return __awaiter(_this, void 0, void 0, function () {
            var accountInfo;
            return __generator(this, function (_a) {
                accountInfo = this.client.getAccountByUsername(this.getUsername());
                this.client.logout(logoutRequest(accountInfo));
                return [2 /*return*/];
            });
        }); };
        this.getToken = function () { return __awaiter(_this, void 0, void 0, function () {
            var accountInfo, request_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accountInfo = this.client.getAccountByUsername(this.getUsername());
                        if (!accountInfo) return [3 /*break*/, 2];
                        request_1 = tokenRequest(accountInfo);
                        return [4 /*yield*/, this.client
                                .acquireTokenSilent(request_1)
                                .then(function (result) {
                                return result.accessToken;
                            })
                                .catch(function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.client
                                                .acquireTokenPopup(request_1)
                                                .then(function (result) {
                                                return result.accessToken;
                                            })
                                                .catch(function (error) {
                                                return null;
                                            })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, null];
                }
            });
        }); };
        this.getTokenSilently = function () { return __awaiter(_this, void 0, void 0, function () {
            var accountInfo, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accountInfo = this.client.getAccountByUsername(this.getUsername());
                        if (!accountInfo) return [3 /*break*/, 2];
                        request = tokenRequest(accountInfo);
                        return [4 /*yield*/, this.client
                                .acquireTokenSilent(request)
                                .then(function (result) {
                                return result.accessToken;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, null];
                }
            });
        }); };
        this.getUsername = function () {
            var _a, _b;
            var currentAccounts = _this.client.getAllAccounts();
            return (_b = (_a = currentAccounts === null || currentAccounts === void 0 ? void 0 : currentAccounts[0]) === null || _a === void 0 ? void 0 : _a.username) !== null && _b !== void 0 ? _b : '';
        };
        this.client = new PublicClientApplication(msalConfig(config));
    }
    AuthManager.getInstance = function (config) {
        if (!AuthManager.instance) {
            AuthManager.instance = new AuthManager(config);
        }
        return AuthManager.instance;
    };
    return AuthManager;
}());

var AuthProviderName;
(function (AuthProviderName) {
    AuthProviderName["PUBLICIS"] = "publicis";
})(AuthProviderName || (AuthProviderName = {}));

// Adapted from axio-retry
var getCurrentState = function (config) {
    var state = config['login_retry'] || {};
    state.retryCount = state.retryCount || 0;
    config['login_retry'] = state;
    return state;
};
var refreshTokenInterceptor = (function (axios, client, config, refresTokenCallback) {
    var authManager = AuthManager.getInstance(config);
    axios.interceptors.request.use(function (config) {
        getCurrentState(config);
        return config;
    });
    axios.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var config, status, state, token, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = error.config;
                    status = error.response.status;
                    state = getCurrentState(config);
                    if (!(status === 401 && state.retryCount < 1 && config.url !== '/auth/login')) return [3 /*break*/, 4];
                    state.retryCount += 1;
                    config.transformRequest = [function (data) { return data; }];
                    return [4 /*yield*/, authManager.getTokenSilently().catch(function () {
                            refresTokenCallback(null);
                            return null;
                        })];
                case 1:
                    token = _a.sent();
                    if (!token) return [3 /*break*/, 3];
                    return [4 /*yield*/, client.login(token, AuthProviderName.PUBLICIS)];
                case 2:
                    response = _a.sent();
                    refresTokenCallback(response);
                    axios.defaults.headers.common.Authorization = "Bearer " + response.accessToken;
                    config.headers.Authorization = "Bearer " + response.accessToken;
                    return [2 /*return*/, new Promise(function (resolve) { return setTimeout(function () { return resolve(axios(config)); }); })];
                case 3: return [2 /*return*/, Promise.reject(error)];
                case 4: return [2 /*return*/, Promise.reject(error)];
            }
        });
    }); });
});

var ApiClient = function (config, refresTokenCallback) {
    var axiosClient = axios.create({
        baseURL: config.server,
        headers: {
            "Access-Control-Allow-Origin": "*",
            "X-Office-Identifier": config.baseUrl,
        },
    });
    var client = {
        axiosClient: axiosClient,
        updateAuthToken: function (token) {
            axiosClient.defaults.headers.common.Authorization = "Bearer " + token;
        },
        fetchBooking: function (query) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axiosClient
                        .get("/booking", { params: __assign({}, query) })
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (response.error) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error;
                    })];
            });
        }); },
        fetchMyBookings: function (userId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axiosClient
                        .get("/booking/" + userId)
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error;
                    })];
            });
        }); },
        deleteBooking: function (booking) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axiosClient
                        .delete("/booking/" + booking.id)
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return booking;
                        }
                    })
                        .catch(function (error) {
                        throw error;
                    })];
            });
        }); },
        createBooking: function (body) { return __awaiter(void 0, void 0, void 0, function () {
            var lightweightBooking;
            return __generator(this, function (_a) {
                lightweightBooking = {
                    title: body.title,
                    description: body.description,
                    typeId: body.typeId,
                    organizerId: body.organizer.id,
                    spaceUserMapping: body.spaceUserMapping,
                    schedule: body.schedule
                };
                return [2 /*return*/, axiosClient
                        .post("/booking", lightweightBooking)
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error;
                    })];
            });
        }); },
        updateBooking: function (id, body) { return __awaiter(void 0, void 0, void 0, function () {
            var lightweightBooking;
            return __generator(this, function (_a) {
                lightweightBooking = {
                    id: id,
                    title: body.title,
                    description: body.description,
                    typeId: body.typeId,
                    organizerId: body.organizer.id,
                    spaceUserMapping: body.spaceUserMapping,
                    schedule: body.schedule
                };
                return [2 /*return*/, axiosClient
                        .put("/booking/" + id, lightweightBooking)
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error;
                    })];
            });
        }); },
        fetchSpaces: function (query) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axiosClient
                        .get("/space", { params: __assign({}, query) })
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error;
                    })];
            });
        }); },
        login: function (accessToken, provider) { return __awaiter(void 0, void 0, void 0, function () {
            var endpoint, body;
            return __generator(this, function (_a) {
                endpoint = "/auth/login";
                body = {
                    token: accessToken,
                    provider: provider,
                };
                return [2 /*return*/, axiosClient
                        .post(endpoint, body)
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error.response.data;
                    })];
            });
        }); },
        fetchSpaceGroups: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axiosClient
                        .get("/space_group")
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error;
                    })];
            });
        }); },
        fetchUser: function (id) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axiosClient
                        .get("/user/" + id)
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error;
                    })];
            });
        }); },
        fetchUsers: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axiosClient
                        .get("/user")
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error;
                    })];
            });
        }); },
        updateUserNoImage: function (id, user) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axiosClient
                        .put("/user/" + id, user)
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error.response.data;
                    })];
            });
        }); },
        updateUser: function (id, user) { return __awaiter(void 0, void 0, void 0, function () {
            var form, organization;
            return __generator(this, function (_a) {
                form = new FormData();
                form.append("firstName", user.firstName);
                form.append("lastName", user.lastName);
                if (!_.isEmpty(user.jobTitle)) {
                    form.append("jobTitle", user.jobTitle);
                }
                if (!_.isEmpty(user.phone)) {
                    form.append("phone", user.phone);
                }
                organization = JSON.stringify(user.organization);
                form.append("organization", organization);
                if (!_.isEmpty(user.rolesList)) {
                    form.append("rolesList", user.rolesList);
                }
                if (!_.isEmpty(user.groupsList)) {
                    form.append("groupsList", user.groupsList);
                }
                if (!_.isEmpty(user.preferredLanguageId)) {
                    form.append("preferredLanguageId", user.preferredLanguageId);
                }
                if (!_.isEmpty(user.avatar) || user.avatar instanceof File) {
                    form.append("avatar", user.avatar);
                }
                return [2 /*return*/, axiosClient
                        .put("/user/" + id, form, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error.response.data;
                    })];
            });
        }); },
        fetchMessage: function (organizationId, messageKey) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axiosClient
                        .get("/message/" + organizationId + "/" + messageKey)
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error;
                    })];
            });
        }); },
        fetchSpaceTags: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axiosClient
                        .get("/space_tag")
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error.message;
                    })];
            });
        }); },
        fetchOrganization: function (id) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axiosClient
                        .get("/organization/" + id)
                        .then(function (response) { return response.data; })
                        .then(function (response) {
                        if (!_.isEmpty(response.error)) {
                            throw response.error;
                        }
                        else {
                            return response.result;
                        }
                    })
                        .catch(function (error) {
                        throw error.message;
                    })];
            });
        }); },
    };
    refreshTokenInterceptor(axiosClient, client, config, refresTokenCallback);
    return client;
};

var TimeUnit;
(function (TimeUnit) {
    TimeUnit["DAY"] = "day";
    TimeUnit["WEEK"] = "week";
    TimeUnit["MONTH"] = "month";
    TimeUnit["YEAR"] = "year";
})(TimeUnit || (TimeUnit = {}));

var WeekDay;
(function (WeekDay) {
    WeekDay["MO"] = "MO";
    WeekDay["TU"] = "TU";
    WeekDay["WE"] = "WE";
    WeekDay["TH"] = "TH";
    WeekDay["FR"] = "FR";
    WeekDay["SA"] = "SA";
    WeekDay["SU"] = "SU";
})(WeekDay || (WeekDay = {}));
[WeekDay.MO, WeekDay.TU, WeekDay.WE, WeekDay.TH, WeekDay.FR, WeekDay.SA, WeekDay.SU];
var momentToCalendarDate = function (date) {
    var dateString = date.format('yyyy-MM-dd');
    return {
        year: date.year(),
        month: date.month() + 1,
        day: date.date(),
        timestamp: date.unix(),
        dateString: dateString
    };
};
var timefromRruleData = function (byHour, byMinute) {
    var openHour = byHour && byHour[0] ? (byHour[0].toString().length == 1 ? '0' + byHour[0].toString() : byHour[0].toString()) : '00';
    var closehour = byHour && byHour[1] ? (byHour[1].toString().length == 1 ? '0' + byHour[1].toString() : byHour[1].toString()) : '00';
    var openMin = byMinute && byMinute[0] ? (byMinute[0].toString().length == 1 ? '0' + byMinute[0].toString() : byMinute[0].toString()) : '00';
    var closeMin = byMinute && byMinute[1] ? (byMinute[1].toString().length == 1 ? '0' + byMinute[1].toString() : byMinute[1].toString()) : '00';
    var openTime = openHour + ':' + openMin;
    var closeTime = closehour + ':' + closeMin;
    return [openTime, closeTime];
};
var isDateInsideRrule = function (date, rrule) {
    var _a;
    var dates = rrule.between(new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0)), new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 23, 59, 59))).map(function (date) {
        var _a;
        return DateTime.fromJSDate(date)
            .toUTC()
            .setZone((_a = rrule.options.tzid) !== null && _a !== void 0 ? _a : 'local', { keepLocalTime: true })
            .toJSDate();
    });
    if (dates.length > 1) {
        var now = DateTime.now().setZone((_a = rrule.options.tzid) !== null && _a !== void 0 ? _a : 'local');
        DateTime.fromJSDate(dates[0]);
        var endDate = DateTime.fromJSDate(dates[dates.length - 1]);
        return now < endDate;
    }
    return false;
};
var formatDateOccupancy = function (date) {
    var month = ("" + (date.getUTCMonth() + 1)).padStart(2, '0');
    var day = ("" + date.getUTCDate()).padStart(2, '0');
    return date.getUTCFullYear() + "-" + month + "-" + day;
};
var openDates = function (rrurle, weeks) {
    var begin = moment();
    var end = begin.clone().add(weeks, 'week');
    var startDate = new Date(Date.UTC(begin.year(), begin.month(), begin.date(), 0, 0));
    var endDate = new Date(Date.UTC(end.year(), end.month(), end.date(), 23, 59, 59));
    var rruleSet = rrulestr(rrurle, { forceset: true });
    var exDates = rruleSet.exdates().map(formatDateOccupancy);
    var dates = rruleSet.between(startDate, endDate).reduce(function (result, date) {
        var newDate = formatDateOccupancy(date);
        if (exDates.includes(newDate)) {
            result.set(newDate, false);
        }
        else {
            result.set(newDate, true);
        }
        return result;
    }, new Map());
    return dates;
};
var weeksForOfficeInAdvanceBookingLimit = function (duration) {
    switch (duration.unitOfTime) {
        case TimeUnit.DAY: {
            return duration.amount > 7 ? Math.ceil(duration.amount / 7) : 1;
        }
        case TimeUnit.WEEK: {
            return duration.amount;
        }
        case TimeUnit.MONTH: {
            return Math.ceil(duration.amount * 30 / 7);
        }
        case TimeUnit.YEAR: {
            return duration.amount * 52;
        }
    }
    return 0;
};

var SpaceModel;
(function (SpaceModel) {
    SpaceModel["POD"] = "POD";
    SpaceModel["SEAT"] = "SEAT";
    SpaceModel["ROOM"] = "ROOM";
})(SpaceModel || (SpaceModel = {}));

var SpaceHelper = /** @class */ (function () {
    function SpaceHelper() {
    }
    SpaceHelper.isOfficeOpen = function (office, date) {
        var _a, _b;
        if (_.isEmpty(office.rrule)) {
            return false;
        }
        var rruleSet = rrulestr(office.rrule, { forceset: true });
        var normalizedDate = new Date(Date.UTC(date.year(), date.month(), date.date(), rruleSet.options.byhour[0]));
        var isOfficeOpen = date.isAfter(new Date(), "day") || isDateInsideRrule(normalizedDate, rruleSet);
        var isWithinBookingRange = date.isBefore(moment().startOf('day').add((_a = office.inAdvanceBookingLimit) === null || _a === void 0 ? void 0 : _a.amount, (_b = office.inAdvanceBookingLimit) === null || _b === void 0 ? void 0 : _b.unitOfTime));
        return isOfficeOpen && isWithinBookingRange;
    };
    SpaceHelper.isOfficeOpened = function (date, officeOpenCache, spacesList, availableSpacesCache, format) {
        var officeIsOpen = officeOpenCache.size > 0 ? officeOpenCache.get(date) : false;
        var m = moment(date);
        if (m.isBefore(moment().startOf("day")) ||
            !officeIsOpen) {
            return null;
        }
        return SpaceHelper.cacheForOccupancy(date, availableSpacesCache);
    };
    SpaceHelper.getRruleCurrentOffice = function (organization) {
        var rruleSet = rrulestr(organization.rrule);
        var rrule = rruleSet instanceof RRuleSet && rruleSet.rrules().length > 0 ? rruleSet.rrules()[0] : rruleSet;
        return rrule !== null && rrule !== void 0 ? rrule : 'DTSTART;TZID=America/New_York:20210201T000000\nRRULE:FREQ=DAILY;BYDAY=MO,TU,WE,TH,FR,SA,SU;BYHOUR=9,17;BYMINUTE=0,0;BYSECOND=0';
    };
    SpaceHelper.occupationForDate = function (spacesList, spacesOpen, date, type) {
        var m = moment(date);
        var allOpenSpaces = spacesList.filter(function (item) {
            var _a;
            return (spacesOpen === null || spacesOpen === void 0 ? void 0 : spacesOpen.get(item.id)) &&
                (((_a = item.type) === null || _a === void 0 ? void 0 : _a.model) === type || type === undefined);
        });
        var bookedSpaces = allOpenSpaces.filter(function (space) { var _a; return (_a = space.bookings) === null || _a === void 0 ? void 0 : _a.find(function (booking) {
            return m.isBetween(moment(booking.schedule.startDate).startOf('day'), moment(booking.schedule.endDate).endOf('day'), undefined, '[]');
        }); });
        return allOpenSpaces.length
            ? {
                occupancy: (bookedSpaces.length / allOpenSpaces.length) * 100,
                availability: allOpenSpaces.length - bookedSpaces.length,
                booked: bookedSpaces.length
            }
            : null;
    };
    SpaceHelper.cacheForOccupancy = function (date, spaceCache, type) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        switch (type) {
            case SpaceModel.SEAT:
                return (_b = (_a = spaceCache.get(date)) === null || _a === void 0 ? void 0 : _a.occupancies.get('seat')) !== null && _b !== void 0 ? _b : null;
            case SpaceModel.ROOM:
                return (_d = (_c = spaceCache.get(date)) === null || _c === void 0 ? void 0 : _c.occupancies.get('room')) !== null && _d !== void 0 ? _d : null;
            case SpaceModel.POD:
                return (_f = (_e = spaceCache.get(date)) === null || _e === void 0 ? void 0 : _e.occupancies.get('pod')) !== null && _f !== void 0 ? _f : null;
        }
        return (_h = (_g = spaceCache.get(date)) === null || _g === void 0 ? void 0 : _g.occupancies.get('all')) !== null && _h !== void 0 ? _h : null;
    };
    SpaceHelper.isOpenSpace = function (space, date, format) {
        var _a, _b, _c, _d, _e;
        /*Rrule is always sending one day off from its original day, therefore, I had to
          convert the day into number and -1 to get right day*/
        var nameToNum = { 'MO': 0, 'TU': 1, 'WE': 2, 'TH': 3, 'FR': 4, 'SA': 5, 'SU': 6 };
        var getDay = moment(date).format('dddd').substr(0, 2).toUpperCase();
        var getSpaceRrule = (_a = space === null || space === void 0 ? void 0 : space.openSchedule) === null || _a === void 0 ? void 0 : _a.rrule;
        var getDays = getSpaceRrule === null || getSpaceRrule === void 0 ? void 0 : getSpaceRrule.substring(getSpaceRrule.indexOf('BYDAY=') + 6).split(',');
        var convertToNumber = function (days) {
            return days === null || days === void 0 ? void 0 : days.map(function (day) {
                return nameToNum[day] - 1;
            });
        };
        var getNewDays = (_b = convertToNumber(getDays)) === null || _b === void 0 ? void 0 : _b.map(function (number) {
            return Object.keys(nameToNum).find(function (key) { return nameToNum[key] === number; });
        });
        var isScheduleExists = (space === null || space === void 0 ? void 0 : space.openSchedule) === undefined;
        var isDateWithinOpenSchedule = date.isBetween((_c = space === null || space === void 0 ? void 0 : space.openSchedule) === null || _c === void 0 ? void 0 : _c.startDate, (_d = space === null || space === void 0 ? void 0 : space.openSchedule) === null || _d === void 0 ? void 0 : _d.endDate, undefined, '[]');
        if ((isScheduleExists || isDateWithinOpenSchedule ||
            date.format(format) === moment((_e = space === null || space === void 0 ? void 0 : space.openSchedule) === null || _e === void 0 ? void 0 : _e.startDate).format(format)) ||
            (getNewDays && getNewDays.includes(getDay)) ||
            (space.openSchedule.startDate === null &&
                space.openSchedule.endDate === null &&
                space.openSchedule.rrule === null)) {
            return SpaceHelper.isActiveSpace(space === null || space === void 0 ? void 0 : space.openDate, format);
        }
        return false;
    };
    SpaceHelper.isActiveSpace = function (value, format) {
        if (value === undefined)
            return false;
        if (typeof value == "boolean")
            return value;
        var dateValue = value;
        var today = moment().startOf('day').format(format);
        var date = moment(dateValue).format(format);
        return date <= today;
    };
    SpaceHelper.spaceGroupFromSpaceList = function (spaceList) {
        var groups = _(spaceList).groupBy(function (space) { return space.groupId; });
        return groups;
    };
    SpaceHelper.availableSpacesPerType = function (spacesList, availableSpacesCache, spaceGroups, date, format) {
        var spacesByModel = _(spacesList)
            .groupBy(function (space) { return space.type.id; })
            .map(function (space, id) { return ({ id: id, space: space }); })
            .value();
        var dateKey = date.format(format);
        var spaceResults = spacesByModel.map(function (model) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            var stats = SpaceHelper.occupationForDate(model.space, (_b = (_a = availableSpacesCache.get(dateKey)) === null || _a === void 0 ? void 0 : _a.openSpaces) !== null && _b !== void 0 ? _b : new Map(), dateKey);
            return {
                id: model.id,
                type: (_c = _.first(model.space)) === null || _c === void 0 ? void 0 : _c.type,
                name: (_e = (_d = _.first(model.space)) === null || _d === void 0 ? void 0 : _d.type.name) !== null && _e !== void 0 ? _e : 'undefined',
                icon: (_g = (_f = _.first(model.space)) === null || _f === void 0 ? void 0 : _f.type.icon) !== null && _g !== void 0 ? _g : 'img/seat.svg',
                availability: (_h = stats === null || stats === void 0 ? void 0 : stats.availability) !== null && _h !== void 0 ? _h : 0,
                occupation: (_j = stats === null || stats === void 0 ? void 0 : stats.occupancy) !== null && _j !== void 0 ? _j : 0,
            };
        });
        var groupByType = _(spaceGroups)
            .groupBy(function (group) { return group.type.id; })
            .map(function (type, group) { return ({ group: group, type: type }); })
            .value();
        var spaceGroupsResults = groupByType.map(function (group) {
            var _a, _b, _c, _d;
            var ids = group.type.map(function (item) { return item.id; });
            var spaces = spacesList.filter(function (item) { return ids.includes(item.group.id); }); // space ids.includes(item.groupId));
            var groupDetails = _.first(group.type);
            var stats = SpaceHelper.groupOccupationForDate(spaces, spaceGroups, date.format(format), format, undefined, groupDetails === null || groupDetails === void 0 ? void 0 : groupDetails.type);
            var icon = (_a = groupDetails === null || groupDetails === void 0 ? void 0 : groupDetails.type.icon) !== null && _a !== void 0 ? _a : 'img/seat.svg';
            return {
                id: group.group,
                type: groupDetails === null || groupDetails === void 0 ? void 0 : groupDetails.type,
                name: (_b = groupDetails === null || groupDetails === void 0 ? void 0 : groupDetails.type.name) !== null && _b !== void 0 ? _b : 'undefined',
                icon: icon,
                availability: (_c = stats === null || stats === void 0 ? void 0 : stats.availability) !== null && _c !== void 0 ? _c : 0,
                occupation: (_d = stats === null || stats === void 0 ? void 0 : stats.occupation) !== null && _d !== void 0 ? _d : 0,
            };
        });
        return spaceResults.concat(spaceGroupsResults);
    };
    SpaceHelper.availableSpaceGroupsForType = function (spacesList, spaceGroupsList, date, type, format) {
        var groups = spaceGroupsList.filter(function (group) { var _a; return ((_a = group.type) === null || _a === void 0 ? void 0 : _a.id) === (type.id ? type.id : type.id); });
        var ids = groups.map(function (group) { return group.id; });
        var m = moment(date);
        var openSpaces = spacesList.filter(function (space) {
            var isBooked = space.bookings.find(function (booking) {
                return m.isBetween(moment(booking.schedule.startDate).startOf('day'), moment(booking.schedule.endDate).endOf('day'), undefined, '[]');
            });
            return (ids.includes(space.group.id) && // check because space us : space.groupId
                SpaceHelper.isOpenSpace(space, date, format) &&
                _.isEmpty(isBooked));
        });
        var groupWithSpaces = groups.map(function (group) {
            var spaces = openSpaces.filter(function (space) { return space.groupId === group.id; });
            group.spaces = spaces;
            return group;
        });
        return groupWithSpaces.filter(function (group) { return group.spaces.length > 0; });
    };
    SpaceHelper.groupOccupationForDate = function (spacesList, spaceGroups, date, format, model, type) {
        var m = moment(date);
        var groupByType = spaceGroups
            ? spaceGroups
                .filter(function (group) { var _a, _b; return type ? ((_a = group.type) === null || _a === void 0 ? void 0 : _a.id) === type.id : ((_b = group.type) === null || _b === void 0 ? void 0 : _b.model) === model; })
                .map(function (group) { return group.id; })
            : null;
        var spacesOpen = spacesList.filter(function (item) {
            return SpaceHelper.isOpenSpace(item, m, format) && (groupByType === null || groupByType === void 0 ? void 0 : groupByType.includes(item.id));
        });
        var spaceGroupOpen = _(spacesOpen)
            .groupBy(function (space) { return space.groupId; })
            .map(function (space, group) { return group; })
            .value();
        var spacesBooked = spacesOpen.filter(function (space) {
            return space.bookings.find(function (booking) {
                return m.isBetween(moment(booking.schedule.startDate).startOf('day'), moment(booking.schedule.endDate).endOf('day'), undefined, '[]');
            });
        });
        var spaceGroupBooked = _(spacesBooked)
            .groupBy(function (space) { return space.groupId; })
            .map(function (space, group) { return group; })
            .value();
        return spaceGroupOpen.length
            ? {
                occupation: (spaceGroupBooked.length / spaceGroupOpen.length) * 100,
                availability: spaceGroupOpen.length - spaceGroupBooked.length,
                booked: spaceGroupBooked.length,
            }
            : null;
    };
    return SpaceHelper;
}());

export { ApiClient, AuthManager, Button, CircularIcon, Dialog, Divider, ModalView, OverlayView, SpaceHelper, SpaceModel, index as StandardAlert, StyledText, ThemeProvider, ThemeUtil, TimeUnit, formatDateOccupancy, isDateInsideRrule, momentToCalendarDate, openDates, timefromRruleData, weeksForOfficeInAdvanceBookingLimit };
//# sourceMappingURL=index.esm.js.map
